/* eslint-disable */
import { createSlice } from "@reduxjs/toolkit";
import { MemberPortalState } from "./memberPortalTypes";
import { fetchMemberPortalInitData } from "./memberThunks";

const initialState: MemberPortalState = {
	member: null,
	groupOwner: null,
	paycheck: null,
	logoSettings: null,
	theme: null,
	dependents: [],
	loading: false,
	error: null
};

const memberPortalSlice = createSlice({
	name: "memberPortal",
	initialState,
	reducers: {
		clearMemberPortal: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchMemberPortalInitData.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchMemberPortalInitData.fulfilled, (state, action) => {
				state.loading = false;
				state.error = null;
				state.member = action.payload.member;
				state.groupOwner = action.payload.groupOwner;
				state.paycheck = action.payload.paycheck;
				state.logoSettings = action.payload.logoSettings;
				state.theme = action.payload.theme;
				state.dependents = action.payload.dependents;
			})
			.addCase(fetchMemberPortalInitData.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message ?? "Failed to fetch member portal data";
			});
	}
});

export const { clearMemberPortal } = memberPortalSlice.actions;
export default memberPortalSlice.reducer;
